export default __webpack_public_path__ + "static/media/honor-swiper-02.92357638.jpg";